import React, { useEffect, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Button } from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import { useDispatch, useSelector } from "react-redux";
import { getUserList, changeStatus } from "../../store/user";
import { RootState } from "../../store";
import { useHistory } from "react-router";
import "./style.css";

const UserList = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState<any>(0);
  const [rowsPerPage, setRowsPerPage] = useState<any>(10);
  const [search, setSearch] = useState("");
  const { userList, loadingUser, totalCount } = useSelector(
    (state: RootState) => state.user
  );

  let history = useHistory();
  useEffect(() => {
    getUsers(search, page, rowsPerPage);
  }, []);

  const getUsers = async (search: any, page: any, limit: any) => {
    dispatch(getUserList({ search: search, page: page + 1, limit: limit }));
  };
  const searching = (e: any) => {
    if (e.key === "Enter") {
      getUsers(search, page, rowsPerPage);
    }
  };
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    getUsers(search, newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    getUsers(search, 0, event.target.value);
    setRowsPerPage(event.target.value);
    setPage(0);
  };
  const edit = async (row: any, option: any) => {
    if (option === "edit") {
      history.push("/user-edit/" + row.user_id);
    } else {
      history.push("/user-view/" + row.user_id);
    }
  };
  const changeRowStatus = async (row: any, option: any) => {
    if (window.confirm("Do you wants to change status ?")) {
      if (option === "approve") {
        dispatch(changeStatus({ data: { active_status: "Y" }, id: row.user_id }));
      } else {
        dispatch(changeStatus({ data: { active_status: "N" }, id: row.user_id }));
      }
    }
  };
  return (
    <>
      <div className="mb-10">
        <input
          className="form-control"
          value={search}
          placeholder="Search "
          onKeyDown={(e) => searching(e)}
          onChange={(event) => setSearch(event.target.value)}
        />
      </div>
      <TableContainer component={Paper}>
        <Table className="table data__table border-0" aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Id</TableCell>
              <TableCell align="center">First Name</TableCell>
              <TableCell align="center">Last Name</TableCell>
              <TableCell align="center">Email</TableCell>
              <TableCell align="center">Active Status</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          {userList.length > 0 && (
            <TableBody>
              {userList.map((row: any, index) => (
                <TableRow key={index}>
                  <TableCell component="th" scope="row">
                    {row?.user_id}
                  </TableCell>
                  <TableCell align="center">{row?.first_name}</TableCell>
                  <TableCell align="center">{row?.last_name}</TableCell>
                  <TableCell align="center">{row?.email}</TableCell>
                  <TableCell align="center">{row?.active_status}</TableCell>
                  <TableCell align="center" >
                    <div className="user-list-action-cell">
                      {row?.active_status != "Y" ? <Button
                        className="btn-sm"
                        variant="contained"
                        color="primary"
                        onClick={() => changeRowStatus(row, "approve")}
                      >
                        Approve
                      </Button> : <Button
                        className="btn-sm delete-btn"
                        variant="contained"
                        color="secondary"
                        onClick={() => changeRowStatus(row, "reject")}
                      >
                        Reject
                      </Button>
                      }
                      <Button
                        className="btn-sm"
                        variant="contained"
                        color="primary"
                        onClick={() => edit(row, "edit")}
                      >
                        Edit
                      </Button>
                      <Button
                        className="btn-sm"
                        variant="contained"
                        color="primary"
                        onClick={() => edit(row, "view")}
                      >
                        View
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>
      {userList.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={Number(totalCount)}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      )}
    </>
  );
};

export default UserList;
